import React, { Suspense, useContext, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Loggedincontext } from './Loggedincontext.js';
import { Routedispatcherprovider } from './Routedispatcher';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import './components/Website/Generalfiles/CSS_GENERAL/bootstrap.css';
import './components/Website/Generalfiles/CSS_GENERAL/dropdown.css';
import './trans.css';
import { Contexthandlerscontext_provider, Contexthandlerscontext } from './Contexthandlerscontext';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import CircularProgress from 'react-cssfx-loading/lib/CircularProgress';
// import pepsicologoresp from './components/Website/Generalfiles/images/pepsicologoresp.png';
import logo from './components/Website/Generalfiles/images/logo.png';

const Websiterouter = React.lazy(() => import('./components/Website/Websiterouter'));
const Login = React.lazy(() => import('./components/Website/Login/Login'));

const App = (props) => {
    let history = useHistory();

    return (
        <div style={{ width: '100%' }}>
            <Contexthandlerscontext_provider>
                <Contexthandlerscontext.Consumer>
                    {(value) => {
                        return (
                            <div style={{ width: '100%' }}>
                                {value.fetchuseauthorizationQueryContext.isFetching && (
                                    <div class="row w-100 allcentered m-0">
                                        <div class="col-lg-12 p-0">
                                            <div class="row m-0 w-100">
                                                <div class="col-lg-12 p-0 d-flex allcentered">
                                                    <img style={{ objectFit: 'contain', widht: '15vh', height: '15vh' }} src={logo} />
                                                </div>
                                                <div class="col-lg-12 p-0 d-flex allcentered mt-3">
                                                    <p class="font-weight-600">Loading...</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {!value.fetchuseauthorizationQueryContext.isFetching && value.fetchuseauthorizationQueryContext.isSuccess && (
                                    <Router>
                                        <Routedispatcherprovider>
                                            <div>
                                                <Suspense
                                                    fallback={
                                                        <div class="row w-100 allcentered m-0">
                                                            <div class="col-lg-12 p-0">
                                                                <div class="row m-0 w-100">
                                                                    <div class="col-lg-12 p-0 d-flex allcentered">
                                                                        <img style={{ objectFit: 'contain', widht: '15vh', height: '15vh' }} src={logo} />
                                                                    </div>
                                                                    <div class="col-lg-12 p-0 d-flex allcentered mt-3">
                                                                        <p class="font-weight-600">Loading...</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                >
                                                    <Route
                                                        render={({ location, match }) => {
                                                            return (
                                                                <TransitionGroup>
                                                                    <Switch key={location.key} location={location}>
                                                                        <Route
                                                                            path="/"
                                                                            render={() => {
                                                                                if (
                                                                                    value.fetchuseauthorizationQueryContext?.data?.data?.loggedin &&
                                                                                    value.fetchuseauthorizationQueryContext?.data?.data?.userinfo?.user_profile?.usertype == 'medgoadmin'
                                                                                ) {
                                                                                    return <Websiterouter />;
                                                                                } else {
                                                                                    return <Login />;
                                                                                }
                                                                            }}
                                                                        />
                                                                        <Route
                                                                            exact
                                                                            path="/home"
                                                                            render={() => {
                                                                                if (
                                                                                    value.fetchuseauthorizationQueryContext?.data?.data?.loggedin &&
                                                                                    value.fetchuseauthorizationQueryContext?.data?.data?.userinfo?.user_profile?.usertype == 'medgoadmin'
                                                                                ) {
                                                                                    return <Websiterouter />;
                                                                                } else {
                                                                                    return <Login />;
                                                                                }
                                                                            }}
                                                                        />
                                                                    </Switch>
                                                                </TransitionGroup>
                                                            );
                                                        }}
                                                    />
                                                </Suspense>
                                            </div>
                                        </Routedispatcherprovider>
                                    </Router>
                                )}
                                <NotificationContainer />
                                <ReactQueryDevtools initialIsOpen />
                            </div>
                        );
                    }}
                </Contexthandlerscontext.Consumer>
            </Contexthandlerscontext_provider>
        </div>
    );
};

export default App;
